module.exports = __webpack_public_path__ + "static/media/backIcon.181e3587.svg";